import { render, staticRenderFns } from "./ICSales.vue?vue&type=template&id=35df405a&"
import script from "./ICSales.vue?vue&type=script&lang=js&"
export * from "./ICSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports